var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDollarCircle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/dollar-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dollar-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.67188 14.3298C8.67188 15.6198 9.66188 16.6598 10.8919 16.6598H13.4019C14.4719 16.6598 15.3419 15.7498 15.3419 14.6298C15.3419 13.4098 14.8119 12.9798 14.0219 12.6998L9.99187 11.2998C9.20187 11.0198 8.67188 10.5898 8.67188 9.36984C8.67188 8.24984 9.54187 7.33984 10.6119 7.33984H13.1219C14.3519 7.33984 15.3419 8.37984 15.3419 9.66984",
    stroke: "url(#paint0_linear_3687_14088)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M12 6V18",
    stroke: "url(#paint1_linear_3687_14088)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z",
    stroke: "url(#paint2_linear_3687_14088)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3687_14088",
    x1: 8.92366,
    y1: 7.08892,
    x2: 17.4652,
    y2: 14.0475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3687_14088",
    x1: 12.0377,
    y1: 5.67692,
    x2: 14.1493,
    y2: 5.87722,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3687_14088",
    x1: 2.75497,
    y1: 1.46154,
    x2: 21.3149,
    y2: 22.5891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB6A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.185417,
    stopColor: "#F0592A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#253C77"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollarCircle);
export default __webpack_public_path__ + "static/media/dollar-circle.bb38201f9c623720bf4a8355be0dd478.svg";
export { ForwardRef as ReactComponent };